module.exports = __webpack_public_path__ + "img/popup-bottom-battery-4.ebad640d.svg";